import checkInConfiguration from "./checkInConfiguration.component";

const checkInConfigurationModule = angular
  .module("app.components.checkInConfiguration", [])
  .component("checkInConfiguration", checkInConfiguration);

export default checkInConfigurationModule;



// WEBPACK FOOTER //
// ./src/components/checkInConfiguration/checkInConfiguration.module.js